import dynamic from 'next/dynamic'
import { BlockProps } from '../BlockProps'
import { IContactBlockData } from './IContactBlockData'
import { TServerSideContactBlockProps } from './TServerSideContactBlockProps'

export const DynamicContactBlock = dynamic<
  BlockProps<IContactBlockData, TServerSideContactBlockProps>
>(() => import('./ContactBlock').then((md) => md.ContactBlock))
